/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'

import { DefaultContent } from '../../components/common/DefaultContent/index'
import { Body, Container, Header, Title } from './styled'

import {
  BatteryChargingVertical,
  CarProfile,
  House,
  Timer,
  UsersFour,
  WarningDiamond,
} from '@phosphor-icons/react'
import { ActionCard } from '../../components/ActionCard'
import { SideTab } from '../../components/SideTab'
import api from '../../services/api'
import { Card } from './components/Card'
import { NewOcurrence } from './components/NewOccurrence'
import { Table } from './components/Table'
import { Modal } from '../../components/Modal'
import { Button } from '../../components/common/Button'

import { Helmet } from 'react-helmet'

const cardData = [
  {
    id: '1',
    title: '',
    subtitle: 'Tempo médio de conclusão ocorrência',
    color: '#006598',
    icon: <Timer size={32} color="#006598" />,
    background: '#fff',
    border: '#308EC6',
  },
  {
    id: '2',
    title: '',
    subtitle: 'Funcionários online',
    color: '#003E5F',
    icon: <UsersFour size={32} color="#003E5F" />,
    background: '#EDF4FC',
    border: '#308EC6',
  },
  {
    id: '3',
    title: '',
    subtitle: 'Ocor. em andamento',
    color: '#150D49',
    icon: <CarProfile size={32} color="#150D49" />,
    background: '#EDF4FC',
    border: '#150D49',
  },
  {
    id: '4',
    title: '',
    subtitle: 'Ocorrências abertas',
    color: '#770A00',
    icon: <BatteryChargingVertical size={32} weight="fill" color="#770A00" />,
    background: '#FFEEE7',
    border: '#770A00',
  },
]

interface ICardProps {
  color: string
  title: string
  subtitle: string
  background: string
  border: string
  icon: React.ReactNode | string
}

interface IHomeEmployeesTable {
  name: string
  number: string
  base: string
  last_occurrence: {
    code: string
    status: string
  }
}

export const Home = () => {
  const [confirm, setConfirm] = useState<boolean>(false)
  const [send, setSend] = useState<boolean>(false)
  const [sended, setSended] = useState<boolean>(false)
  const [card, setCard] = useState<ICardProps[]>(cardData)
  const [table, setTable] = useState<IHomeEmployeesTable[]>([])

  const getHomeCards = () => {
    api
      .get('/v1/dashboard/home/cards')
      .then((response) => {
        const {
          occurrence_average_conclusion_time,
          employees_online,
          in_progress_occurrences,
          opened_occurrences,
        } = response.data
        cardData[0].title = formatTime(occurrence_average_conclusion_time)
        cardData[1].title = employees_online
        cardData[2].title = in_progress_occurrences
        cardData[3].title = opened_occurrences
        setCard(cardData)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const getHomeEmployeesTable = () => {
    api
      .get('/v1/dashboard/home/employees-table')
      .then((response) => {
        console.log('🚀 ~ .then ~ response:', response.data)
        setTable(response.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const formatTime = (minutes: number) => {
    if (minutes >= 60) {
      const hours = Math.floor(minutes / 60)
      const remainingMinutes = Math.floor(minutes % 60)
      if (remainingMinutes > 0) {
        return `${hours}:${
          remainingMinutes < 10 ? '0' : ''
        }${remainingMinutes} h`
      } else {
        return `${hours} h`
      }
    } else {
      return `${Math.floor(minutes)} min`
    }
  }

  useEffect(() => {
    getHomeCards()
    getHomeEmployeesTable()

    const getHomeCardsInterval = setInterval(() => {
      getHomeCards()
    }, 10000)

    const getHomeEmployeesInterval = setInterval(() => {
      getHomeEmployeesTable()
    }, 10000)

    return () => {
      clearInterval(getHomeCardsInterval)
      clearInterval(getHomeEmployeesInterval)
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>Previx - Home</title>
        <meta name="Previx - Home" content="Página inicial previx" />
      </Helmet>
      <DefaultContent
        icon={<House size={32} weight="fill" color="#003E5F" />}
        title="Previx - Home"
      >
        <Container>
          <Header>
            {card.map((card, idx) => {
              return (
                <Card
                  key={idx}
                  title={card.title}
                  subtitle={card.subtitle}
                  background={card.background}
                  border={card.border}
                  color={card.color}
                  icon={card.icon}
                />
              )
            })}
            <div className="info">
              <Title>Acionar funcionários em vigilância</Title>
              <ActionCard.Root>
                <ActionCard.Content
                  onclick={() => setSend((prev) => !prev)}
                  background="#D92F18"
                  border="#770A00"
                  color="#fff"
                >
                  <ActionCard.Icon
                    icon={
                      <WarningDiamond size={70} weight="fill" color="#770A00" />
                    }
                  />
                  <ActionCard.Information value="Enviar aviso de novas ocorrências" />
                </ActionCard.Content>
              </ActionCard.Root>
            </div>
          </Header>
          <Body>
            <Table data={table} />
          </Body>
        </Container>
      </DefaultContent>

      <SideTab
        open={send}
        toggleFunction={() => setSend((prev) => !prev)}
        title="Enviar aviso de novas ocorrências"
      >
        <NewOcurrence setCloseAll={() => setConfirm((prev) => !prev)} />
      </SideTab>

      <Modal.Root
        setIsOpenController={() => {
          setSend((prev) => !prev)
          setConfirm((prev) => !prev)
        }}
        top="50%"
        left="50%"
        height="fit-content"
        width="fit-content"
        borderradius="8px"
        padding="0.5rem"
        open={confirm}
        backgroundcolor="#fff"
      >
        <Modal.Header
          onclick={() => {
            setSend((prev) => !prev)
            setConfirm(false)
          }}
        />
        <Modal.Content
          value="Aviso enviado!"
          subvalue="Os funcionários logo irão receber o comunicado"
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#308EC6"
            onClick={() => {
              setConfirm(false)
              setSend(false)
            }}
          >
            <Button.Content title="OK" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
    </>
  )
}
